var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"dark":"","padless":""}},[_c('v-card',{staticClass:"primary white--text text-center",attrs:{"flat":"","tile":"","width":"100%"}},[_c('v-divider'),_c('v-card-text',{staticClass:"white--text"},[_vm._v(" "+_vm._s(new Date().getFullYear())+" — "),_c('strong',[_vm._v("GLocation")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }